module.exports = __webpack_public_path__ + "img/OBUHomePage_02.4f89b09f.png";